// extracted by mini-css-extract-plugin
module.exports = {"variantGhost":"ReportButton-variantGhost-3a0KW","colorRegular":"ReportButton-colorRegular-3VUmr"};